export default __webpack_public_path__ + "static/media/spin-bg-3.6f146f4d.png";